<div class="wrapper-lg" *ngIf="item">
    <app-breadcrumbs [items]="[
                     { url: '/diploma-supplements', text: 'diplomaSupplement_listTitle' },
                     { text: 'diplomaSupplement_formTitle' }]"></app-breadcrumbs>

    <header class="content-header">
        <h1>
            {{'diplomaSupplement_formTitle' | translate}}
            <span class="badge"
                  [class.text-bg-secondary]="item.Status == 'Draft'"
                  [class.text-bg-success]="item.Status == 'Registered'">
                {{'diplomaSupplement_status' + item.Status | translate}}
            </span>
        </h1>
        <aside>
            <div ngbDropdown *ngIf="item.Id">
                <button type="button" class="btn btn-outline" ngbDropdownToggle>
                    <i class="fi fi-rs-download"></i>
                    {{'download' | translate}}
                </button>
                <div ngbDropdownMenu>
                    <button ngbDropdownItem (click)="download('pdf')">PDF (LV)</button>
                    <button ngbDropdownItem (click)="download('pdfen')">PDF (EN)</button>
                    <button ngbDropdownItem (click)="download('xml')">XML</button>
                </div>
            </div>

            <button type="button" class="btn btn-outline-primary ms-1" (click)="refresh()">
                <i class="fi fi-rs-refresh" *ngIf="!isRefreshing"></i>
                <span class="spinner-border spinner-border-sm" *ngIf="isRefreshing"></span>
                {{'diplomaSupplement_btnRefresh' | translate}}
            </button>
        </aside>
    </header>

    <div class="content-desc">
        {{programName}} / {{item.FirstName}} {{item.LastName}} / {{item.PersonCode}}
    </div>

    <ng-container *ngIf="version">
        <app-alert level="info" *ngIf="!changes.length">{{'diplomaSupplement_noChanges' | translate}}</app-alert>
        <app-alert level="warning" *ngIf="changes.length">
            <p><strong>{{'diplomaSupplement_hasChanges' | translate | formatString:[changes.length]}}</strong></p>
            <div *ngFor="let n of changes">&mdash; {{n}}</div>
        </app-alert>
    </ng-container>

    <app-alert level="success" *ngIf="!isEditing && item.Status == 'Registered'">
        <div><strong>{{'diplomaSupplement_registeredTitle' | translate}}</strong></div>
        <div>{{item.Registered | appDate:'datetime'}} &bull; {{item.RegisteredBy}}</div>
    </app-alert>

    <section class="block-em">
        <div class="row">
            <div class="col-3">
                <div class="form-field required" *ngIf="isEditing">
                    <label class="form-label">{{'diplomaSupplement_lblDiplomaSeries' | translate}}</label>
                    <input class="form-control" name="diplomaSeries" [(ngModel)]="editModel.DiplomaSeries" required
                           [disabled]="!item.CanEditDiplomaSeries" />

                    <div class="mt-1 value-wrapper" *ngIf="version?.DiplomaSeries && version.DiplomaSeries != item.DiplomaSeries">
                        <div class="value-prev">{{item.DiplomaSeries}}</div>
                        <div class="value-next">{{version.DiplomaSeries}}</div>
                    </div>
                </div>

                <div *ngIf="!isEditing" class="data-value">
                    <label>{{'diplomaSupplement_lblDiplomaSeries' | translate}}</label>
                    <div>{{item.DiplomaSeries}}</div>
                </div>
            </div>

            <div class="col-3">
                <div class="form-field required" *ngIf="isEditing">
                    <label class="form-label">{{'diplomaSupplement_lblDiplomaNumber' | translate}}</label>
                    <input class="form-control" name="diplomaNumber" [(ngModel)]="editModel.DiplomaNumber" required
                           [disabled]="!item.CanEditDiplomaNumber" />

                    <div class="mt-1 value-wrapper" *ngIf="version?.DiplomaNumber && version.DiplomaNumber != item.DiplomaNumber">
                        <div class="value-prev">{{item.DiplomaNumber}}</div>
                        <div class="value-next">{{version.DiplomaNumber}}</div>
                    </div>
                </div>

                <div *ngIf="!isEditing" class="data-value">
                    <label>{{'diplomaSupplement_lblDiplomaNumber' | translate}}</label>
                    <div>{{item.DiplomaNumber}}</div>
                </div>
            </div>
        </div>
    </section>

    <app-diploma-supplement-value-block [item]="getBlock('1')" [translate]="translate">
        <app-diploma-supplement-value-pairs [items]="getValues('1')" [translate]="translate"></app-diploma-supplement-value-pairs>
    </app-diploma-supplement-value-block>

    <app-diploma-supplement-value-block [item]="getBlock('2')" [translate]="translate">
        <app-diploma-supplement-value-pairs [items]="getValues('2')" [translate]="translate"></app-diploma-supplement-value-pairs>
    </app-diploma-supplement-value-block>

    <app-diploma-supplement-value-block [item]="getBlock('3')" [translate]="translate">
        <app-diploma-supplement-value-pairs [items]="getValues('3')" [translate]="translate"></app-diploma-supplement-value-pairs>
    </app-diploma-supplement-value-block>

    <app-diploma-supplement-value-block [item]="getBlock('4')" [translate]="translate">
        <app-diploma-supplement-value-pairs [items]="getValues('4')" [translate]="translate"></app-diploma-supplement-value-pairs>

        <label class="title-label mb-1">4.3 {{'diplomaSupplement_lblProgramDetailsResults' | translate}}</label>
        <div class="table-style-block">
            <table class="table value-table">
                <thead>
                    <tr>
                        <th class="ix-cell text-nowrap">{{'diplomaSupplement_lblNr' | translate}}</th>
                        <th class="text-nowrap min-cell">{{text('diplomaSupplement_lblPart', 'lv')}} / {{text('diplomaSupplement_lblPart', 'en')}}</th>
                        <th>{{text('diplomaSupplement_lblCourse', 'lv')}} / {{text('diplomaSupplement_lblCourse', 'en')}}</th>
                        <th class="text-end min-cell text-nowrap">{{'diplomaSupplement_lblEcts' | translate}}</th>
                        <th class="text-nowrap min-cell">{{text('diplomaSupplement_lblAssessment', 'lv')}} / {{text('diplomaSupplement_lblAssessment', 'en')}}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let c of courseGrades; let ci = index">
                        <td>{{ci + 1}}.</td>
                        <td>{{c.part}}</td>
                        <td>
                            <div>{{c.Name}}</div>
                            <div class="text-sub">{{c.NameEn}}</div>
                        </td>
                        <td class="text-end">{{c.Ects}}</td>
                        <td *ngIf="c.Grade">
                            <div>{{c.Grade}} ({{c.GradeText}})</div>
                            <div class="text-sub">{{c.GradeEn}} ({{c.GradeTextEn}})</div>
                        </td>
                        <td *ngIf="!c.Grade">
                            <div>{{c.GradeText}}</div>
                            <div class="text-sub">{{c.GradeTextEn}}</div>
                        </td>
                    </tr>

                    <tr *ngIf="item.Thesis?.Title">
                        <td>{{courseGrades.length + 1}}.</td>
                        <td></td>
                        <td>
                            <div>{{item.Thesis.Title}}</div>
                            <div class="text-sub">{{item.Thesis.TitleEn}}</div>
                        </td>
                        <td class="text-end">{{item.Thesis.Ects}}</td>
                        <td>
                            <div>{{item.Thesis.Grade}} ({{item.Thesis.GradeText}})</div>
                            <div class="text-sub">{{item.Thesis.Grade}} ({{item.Thesis.GradeTextEn}})</div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <label class="title-label mb-1">4.4 {{'diplomaSupplement_lblGradeDistribution' | translate}}</label>
        <div class="table-style-block">
            <table class="table value-table">
                <thead>
                    <tr>
                        <th class="text-nowrap">{{text('diplomaSupplement_lblGrade', 'lv')}} / {{text('diplomaSupplement_lblGrade', 'en')}}</th>
                        <th class="text-end text-nowrap">{{text('diplomaSupplement_lblDistribution', 'lv')}} / {{text('diplomaSupplement_lblDistribution', 'en')}}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let g of item.GradeStatistics">
                        <td>{{g.Meaning}} / {{g.MeaningEn}}</td>
                        <td class="text-end">{{g.Percentage}}%</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="data-value">
            <label>{{text('diplomaSupplement_lblWeightedAverageGrade', 'lv')}} / {{text('diplomaSupplement_lblWeightedAverageGrade', 'en')}}</label>
            <div>{{item.WeightedAverageGrade}}</div>
        </div>

        <app-diploma-supplement-value-pairs [items]="getValues('4.5')" [translate]="translate"></app-diploma-supplement-value-pairs>
    </app-diploma-supplement-value-block>

    <app-diploma-supplement-value-block [item]="getBlock('5')" [translate]="translate">
        <app-diploma-supplement-value-pairs [items]="getValues('5')" [translate]="translate"></app-diploma-supplement-value-pairs>
    </app-diploma-supplement-value-block>

    <app-diploma-supplement-value-block [item]="getBlock('6')" [translate]="translate">
        <app-diploma-supplement-value-pairs [items]="getValues('6')" [translate]="translate"></app-diploma-supplement-value-pairs>
    </app-diploma-supplement-value-block>

    <app-diploma-supplement-value-block [item]="getBlock('7')" [translate]="translate">
        <app-diploma-supplement-value-pairs [items]="getValues('7')" [translate]="translate"></app-diploma-supplement-value-pairs>
    </app-diploma-supplement-value-block>

    <div class="form-actions">
        <div class="form-actions-group">
            <button class="btn btn-outline-primary" type="button" (click)="save(true)" *ngIf="isEditing">
                <i class="fi fi-rs-check" *ngIf="!isSubmitting"></i>
                <span class="spinner-border spinner-border-sm" *ngIf="isSubmitting"></span>
                {{'diplomaSupplement_btnSubmit' | translate}}
            </button>
        </div>

        <div class="form-actions-group">
            <button class="btn btn-outline" type="button" [routerLink]="['/diploma-supplements'] | localize">
                {{(isEditing ? 'cancel' : 'close') | translate}}
            </button>

            <button class="btn btn-primary" type="button" (click)="save()" *ngIf="isEditing && !isRegistered">
                <span class="spinner-border spinner-border-sm" *ngIf="isSaving"></span>
                {{'save' | translate}}
            </button>
        </div>
    </div>
</div>
